.content {
  position: relative;
  height: 100%;

  @media screen and (min-width: $bp-medium) {
    max-height: calc(100% - 4rem);
  }
}
